import { queryOptions } from "@tanstack/react-query";

import { agentQueryKeys } from "~/api/agent/agent-query-keys";
import { getAgentLatestDisplayName } from "~/api/agent/get-agent-latest-display-name";
import clientSDK from "~/api/clientSDK";
import { DEFAULT_CACHE_TIME } from "~/constants";

export const agentQueryOptions = {
  byId: (id: string) =>
    queryOptions({
      queryKey: agentQueryKeys.byId(id),
      queryFn: () => clientSDK.getAgent(id),
      select: (agent) => ({ ...agent, displayName: getAgentLatestDisplayName(agent) }),
      staleTime: DEFAULT_CACHE_TIME,
    }),
};
